"use strict";

var CardConfig = require('./card/cardConfig');
var StoredCardConfig = require('./card/storedCardConfig');
var BcmcConfig = require('./bcmc/bcmcConfig');
var BoletoConfig = require('./boleto/boletoConfig');
var GooglePayConfig = require('./googlePay/googlePayConfig');
var KlarnaConfig = require('./klarna/klarnaConfig');
var CashAppConfig = require('./cashapp/cashappConfig');
var UpiConfig = require('./upi/upiConfig');
var ApplePayConfig = require('./applePay/applePayConfig');
var AmazonPayConfig = require('./amazonPay/amazonPayConfig');
var PayPalConfig = require('./paypal/paypalConfig');
var GiftCardsConfig = require('./giftcards/giftcardsConfig');
var PayPalFastlaneConfig = require('./paypal/paypalFastlaneConfig');
var store = require('../../../../../../config/store');
var helpers = require('../helpers');
var _require = require('../../commons/httpClient'),
  httpClient = _require.httpClient;
function getPaymentMethodsConfiguration(email, amount, AdyenPaymentMethods) {
  var cardConfig = new CardConfig(store, helpers, email, amount).getConfig();
  var storedCardConfig = new StoredCardConfig(store, helpers).getConfig();
  var bcmcConfig = new BcmcConfig(store, helpers).getConfig();
  var boletoConfig = new BoletoConfig().getConfig();
  var googlePayConfig = new GooglePayConfig(helpers).getConfig();
  var klarnaConfig = new KlarnaConfig(helpers, window.klarnaWidgetEnabled).getConfig();
  var cashAppConfig = new CashAppConfig(helpers).getConfig();
  var upiConfig = new UpiConfig(helpers).getConfig();
  var applePayConfig = new ApplePayConfig(helpers, amount).getConfig();
  var payPalConfig = new PayPalConfig(store, helpers).getConfig();
  var amazonPayConfig = new AmazonPayConfig(store, helpers, AdyenPaymentMethods).getConfig();
  var giftCardsConfig = new GiftCardsConfig(store, httpClient, helpers).getConfig();
  var payPalFastlaneConfig = new PayPalFastlaneConfig(store, helpers).getConfig();
  return {
    scheme: cardConfig,
    bcmc: bcmcConfig,
    storedCard: storedCardConfig,
    boletobancario: boletoConfig,
    paywithgoogle: googlePayConfig,
    googlepay: googlePayConfig,
    paypal: payPalConfig,
    amazonpay: amazonPayConfig,
    giftcard: giftCardsConfig,
    applepay: applePayConfig,
    klarna: klarnaConfig,
    klarna_account: klarnaConfig,
    klarna_paynow: klarnaConfig,
    cashapp: cashAppConfig,
    upi: upiConfig,
    fastlane: payPalFastlaneConfig
  };
}
module.exports = getPaymentMethodsConfiguration;